/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import FormCreator from "../../../../components/Forms/FormCreator";
import { eventQuestionAnswerTasklistFormData } from "./data/EventQuestionAnswerListForm.data";

const EventQuestionAnswerFilterForm = forwardRef((props, ref) => {
    const filterFormRef = useRef();
    const [filterForm, setFilterForm] = useState(eventQuestionAnswerTasklistFormData);

    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const filterFormData = filterFormRef.current.getFormData();
                return filterFormData;
            }
            return null;
        }
    }));

    return (
        <FormCreator ref={filterFormRef} {...filterForm} />
    )

})

export default EventQuestionAnswerFilterForm